/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAwsManagementAccount extends models.ServiceAccountNativeDetailsBaseForAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAwsManagementAccount");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAwsManagementAccount.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAwsManagementAccount>): ServiceAccountNativeDetailsForAwsManagementAccount {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAwsManagementAccount(), model);
        ServiceAccountNativeDetailsForAwsManagementAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAwsManagementAccount>): ServiceAccountNativeDetailsForAwsManagementAccount {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAwsManagementAccount.newInstance(<ServiceAccountNativeDetailsForAwsManagementAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAwsManagementAccount) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAwsManagementAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAwsManagementAccount): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAwsManagementAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of AWS Organization Hierarchy Root
     */
    root_id: string;

}
